import axios from 'axios';

export const getActiveCrmGroups = (crmName) => {
  return new Promise((resolve, reject) => {
    axios
      .get('/api/?entity=vessel&action=getActiveCrmGroups&crm=' + crmName)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};
